export const payments = {
  tableHeaders: [
    {
      titleKey: 'id_transaction',
      key: 'transactionId'
    },
    {
      titleKey: 'status',
      key: 'status',
      type: 'boolean-circle'
    },
    {
      titleKey: 'date',
      key: 'date',
      type: 'date',
      options: {
        format: "DD, MMM 'YY"
      }
    },
    {
      titleKey: 'amount',
      key: 'amount',
      getValue: row => row.amount + (row.currency === 'EUR' ? ' €' : ' $')
    },
    {
      titleKey: 'donation',
      key: 'Donation',
      getValue: row => (row.donation ? row.donation.toFixed(2) + (row.currency === 'EUR' ? ' €' : ' $') : '-')
    },
    {
      titleKey: 'type_transaction',
      key: 'TRXType',
      type: 'enum'
    }
  ],
  radioFilter: []
}

export const paymentDetails = {
  tableHeaders: [
    {
      titleKey: 'id_transaction',
      key: 'transactionId'
    },
    {
      titleKey: 'status',
      key: 'status',
      type: 'boolean-circle'
    },
    {
      titleKey: 'date',
      key: 'date',
      type: 'date',
      options: {
        format: "DD, MMM 'YY"
      }
    },
    {
      titleKey: 'amount',
      key: 'amount',
      getValue: row => row.amount + (row.currency === 'EUR' ? ' €' : ' $')
    },
    {
      titleKey: 'type_transaction',
      key: 'TRXType',
      type: 'enum'
    }
  ]
}
// TODO: add localization
export const donationFee = {
  tableHeaders: [
    {
      titleKey: 'number_sepa_card',
      key: 'lastDigits',
      getValue: row => {
        if (row.lastDigits) {
          return (row.method === 'sepa' ? '************************' : '**** **** **** ') + row.lastDigits
        } else return '-'
      }
    },
    {
      titleKey: 'payment_method',
      key: 'method',
      getValue: row => (row.method === 'sepa' ? 'SEPA' : 'Carta di Credito')
    },
    {
      titleKey: 'amount',
      key: 'amount',
      getValue: row => row.amount + (row.currency === 'USD' || row.currency === 'usd' ? ' $' : ' €')
    },
    {
      titleKey: 'paid',
      key: 'paid',
      type: 'boolean-circle'
    },
    {
      titleKey: 'period',
      key: 'month',
      getValue: row => row.month + '/' + row.year
    }
  ],
  radioFilter: [
    {
      titleKey: 'all',
      value: null,
      key: 'paid'
    },
    {
      titleKey: 'paid',
      value: true,
      key: 'paid'
    },
    {
      titleKey: 'waiting_payment',
      value: false,
      key: 'paid'
    }
  ],
  rowActions: [
    {
      title: 'Details',
      name: 'details',
      icon: 'icon-look'
    }
  ]
}

export const donappFee = {
  tableHeaders: [
    {
      titleKey: 'type_account',
      key: 'accountType'
    },
    {
      titleKey: 'amount',
      key: 'amount',
      getValue: row => row.amount + (row.currency === 'USD' || row.currency === 'usd' ? ' $' : ' €')
    },
    {
      titleKey: 'paid',
      key: 'paid',
      type: 'boolean-circle'
    },
    {
      titleKey: 'date',
      key: 'dueDate',
      type: 'date',
      options: {
        format: "DD, MMM 'YY"
      }
    }
  ],
  radioFilter: [
    {
      titleKey: 'all',
      value: null,
      key: 'paid'
    },
    {
      titleKey: 'paid',
      value: true,
      key: 'paid'
    },
    {
      titleKey: 'waiting_payment',
      value: false,
      key: 'paid'
    }
  ],
  rowActions: []
}

export const posDevices = {
  tableHeaders: [
    {
      titleKey: 'id_terminal',
      key: 'terminalId'
    },
    {
      titleKey: 'model',
      key: 'model'
    },
    {
      titleKey: 'serial_num',
      key: 'serialNo'
    },
    {
      titleKey: 'status',
      key: 'status',
      type: 'boolean-circle',
      getValue: row => row.status === 1
    },
    {
      titleKey: 'date',
      key: 'date',
      type: 'date',
      options: {
        format: "DD, MMM 'YY"
      }
    }
  ],
  radioFilter: [
    {
      titleKey: 'all',
      value: null,
      key: 'status'
    },
    {
      titleKey: 'active',
      value: 1,
      key: 'status'
    },
    {
      titleKey: 'inactive',
      value: 0,
      key: 'status'
    }
  ],
  rowActions: [
    {
      titleKey: 'change_status',
      name: 'change-status',
      key: 'changeStatus',
      dynamicIcon: function(row) {
        return row.status ? 'icon-toggle-on' : 'icon-toggle-off'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/merchants/tables/settings.js